import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { faqs } from "../data/menu";

const FAQ = () => {
  const [open, setOpen] = useState(0);

  return (
    <section
      id="faq"
      className="relative py-24 sm:py-32 bg-[var(--sn-bg)] overflow-hidden"
      data-testid="faq-section"
    >
      <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="h-px w-10 bg-[var(--sn-gold)]" />
            <span className="text-[var(--sn-gold)] tracking-[0.3em] text-xs uppercase">
              Dúvidas Frequentes
            </span>
            <span className="h-px w-10 bg-[var(--sn-gold)]" />
          </div>
          <h2
            className="font-display text-4xl sm:text-5xl lg:text-6xl text-[var(--sn-cream)]"
            data-testid="faq-headline"
          >
            Perguntas que <span className="italic gold-text">ouvimos</span>{" "}
            todos os dias.
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.45, delay: i * 0.05 }}
                className={`border ${
                  isOpen
                    ? "border-[var(--sn-gold)] bg-[var(--sn-bg-surface)]/60"
                    : "border-[var(--sn-border)] bg-[var(--sn-bg-surface)]/30"
                } transition-all duration-300`}
                data-testid={`faq-item-${i}`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left"
                  data-testid={`faq-trigger-${i}`}
                >
                  <span className="font-display text-lg sm:text-xl text-[var(--sn-cream)]">
                    {f.q}
                  </span>
                  <span
                    className={`w-9 h-9 rounded-full border ${
                      isOpen
                        ? "border-[var(--sn-gold)] bg-[var(--sn-gold)] text-[var(--sn-bg-deep)]"
                        : "border-[var(--sn-gold)] text-[var(--sn-gold)]"
                    } flex items-center justify-center shrink-0 transition-all`}
                  >
                    {isOpen ? <Minus size={16} /> : <Plus size={16} />}
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.35 }}
                      className="overflow-hidden"
                    >
                      <p className="px-6 pb-6 text-[var(--sn-cream-soft)]/85 leading-relaxed">
                        {f.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
